import React from 'react';
import { ctaContent, pricingContent } from '../data/mock';
import { Button } from './ui/button';
import { ChevronRight, ExternalLink } from 'lucide-react';

const CTASection = ({ onContactClick }) => {
  return (
    <section className="py-20 lg:py-28 bg-slate-900 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />
        <div className="absolute top-1/2 right-1/4 w-80 h-80 bg-teal-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Content */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
          <span className="md:hidden">まずは無料で<br />試してみませんか？</span>
          <span className="hidden md:inline">{ctaContent.title}</span>
        </h2>
        <p className="text-lg sm:text-xl text-slate-300 mb-10 whitespace-pre-line">
          {ctaContent.subtitle}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Button
            onClick={onContactClick}
            size="lg"
            className="free_assessment_button bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-semibold px-10 py-6 text-lg transition-all hover:shadow-lg hover:shadow-cyan-500/25 group"
          >
            {ctaContent.primaryCta}
            <ChevronRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            asChild
            variant="outline"
            size="lg"
            className="sample_report__button border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white px-10 py-6 text-lg"
          >
            <a href={pricingContent.sampleReportUrl} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="mr-2 w-5 h-5" />
              {ctaContent.secondaryCta}
            </a>
          </Button>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-500">
          <span className="flex items-center gap-2">
            <svg className="w-4 h-4 text-cyan-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            月2記事無料
          </span>
          <span className="flex items-center gap-2">
            <svg className="w-4 h-4 text-cyan-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            初期費用なし
          </span>
          <span className="flex items-center gap-2">
            <svg className="w-4 h-4 text-cyan-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            最短1、2営業日でレポート
          </span>
        </div>
      </div>
    </section>
  );
};

export default CTASection;